module.exports = __webpack_public_path__ + "img/wuyibing.cfa64772.jpg";